{
  "gain": 1,
  "pan": 0,
  "fx_EQ_isActive": false,
  "fx_EQ_low": 0,
  "fx_EQ_mid": 0,
  "fx_EQ_high": 0,
  "send_reverbA": -60,
  "send_reverbB": -60,
  "send_delayA": -60,
  "send_delayB": -60,
  "lpf_cutoff": 20000,
  "openHat_swing": 0,
  "openHat_tone": 0,
  "openHat_volume": -3,
  "openHat_release": 1,
  "openHat_reverbSend": -30,
  "openHat_drumkit": "Trap 1",
  "closedHat_swing": 0,
  "closedHat_tone": 0,
  "closedHat_volume": -3,
  "closedHat_release": 1,
  "closedHat_reverbSend": -30,
  "closedHat_drumkit": "Trap 1",
  "snare_swing": 0,
  "snare_tone": 0,
  "snare_volume": -3,
  "snare_release": 1,
  "snare_reverbSend": -30,
  "snare_drumkit": "Trap 1",
  "kick_swing": 0,
  "kick_tone": 0,
  "kick_volume": -3,
  "kick_release": 1,
  "kick_reverbSend": -30,
  "kick_drumkit": "Trap 1",
  "_metadata": {
    "instrumentType": "groovebox"
  }
}